export const getFileUploadMaxSizeState = (state) => {
    var _a, _b;
    return (_b = (_a = state === null || state === void 0 ? void 0 : state.domain) === null || _a === void 0 ? void 0 : _a.file) === null || _b === void 0 ? void 0 : _b.fileUploadMaxSize;
};
//# sourceMappingURL=getFileUploadMaxSizeState.js.map